export const SURVEY_TYPES = {
  text: "text",
  number: "number",
  singleChoice: "multiplerb",
  multipleChoice: "multiplechk",
  image: "image"
};

export const MAX_SURVEY_LIMIT = 50;
export const MAX_IMAGE_LIMIT = 25;
export const MAX_NESTING_LEVEL = 3;

export const SURVEY_TYPE_LABELS = {
  [SURVEY_TYPES.text]: "Texto",
  [SURVEY_TYPES.number]: "Numérico",
  [SURVEY_TYPES.singleChoice]: "Opción única",
  [SURVEY_TYPES.multipleChoice]: "Selección múltiple",
  [SURVEY_TYPES.image]: "Subir imagen"
};

export const SURVEY_SELECTION_OPTIONS = [
  { value: SURVEY_TYPES.text, text: SURVEY_TYPE_LABELS[SURVEY_TYPES.text] },
  { value: SURVEY_TYPES.number, text: SURVEY_TYPE_LABELS[SURVEY_TYPES.number] },
  {
    value: SURVEY_TYPES.singleChoice,
    text: SURVEY_TYPE_LABELS[SURVEY_TYPES.singleChoice]
  },
  {
    value: SURVEY_TYPES.multipleChoice,
    text: SURVEY_TYPE_LABELS[SURVEY_TYPES.multipleChoice]
  },
  { value: SURVEY_TYPES.image, text: SURVEY_TYPE_LABELS[SURVEY_TYPES.image] }
];

export const CHILD_QUESTION_TYPES = [...SURVEY_SELECTION_OPTIONS];

export const NO_CONDITIONAL_TYPE = "none";

export const NO_CONDITIONAL_LABEL = "Sin condicional";

export const CONDITIONAL_MENU_ITEMS = [
  { value: NO_CONDITIONAL_TYPE, text: NO_CONDITIONAL_LABEL },
  ...CHILD_QUESTION_TYPES
];

export const QUESTION_CARD_VARIANTS = {
  [SURVEY_TYPES.text]: {
    chipLabel: "Texto",
    answerPlaceholder: "Escriba su respuesta",
    showFooter: true,
    answerFieldProps: {
      multiline: true,
      rows: 2
    }
  },

  [SURVEY_TYPES.number]: {
    chipLabel: "Numérico",
    answerPlaceholder: "Escriba su respuesta, solo números",
    showFooter: true,
    answerFieldProps: {
      multiline: true,
      rows: 2
    }
  },

  [SURVEY_TYPES.image]: {
    chipLabel: "Imagen",
    showFooter: false
  },

  [SURVEY_TYPES.multipleChoice]: {
    chipLabel: "Opción múltiple",
    showFooter: true
  },

  [SURVEY_TYPES.singleChoice]: {
    chipLabel: "Opción única",
    showFooter: true
  }
};

export const SURVEY_QUESTION_CHROME = {
  titleColor: "rgba(0, 0, 0, 0.72)",
  titleFontWeight: 600,
  chipBackground: "#E0E0E0",
  chipText: "rgba(0, 0, 0, 0.72)",
  plainBackground: "#ECF2F8",
  plainBorder: "#A9C0D8",
  conditionalRootBackground: "#FFEDD5",
  conditionalRootBorder: "#FDBA74",
  conditionalChildBackground: "#FFF6EB",
  conditionalChildBorder: "#FFC7A7",
  branchBorder: "#FB923C",
  branchLabel: "#E6752E",
  addOption: "#27588D",
  fieldBackground: "#F5F5F5",
  fieldText: "rgba(0, 0, 0, 0.87)",
  placeholderText: "rgba(0, 0, 0, 0.45)",
  noteText: "rgba(0, 0, 0, 0.60)",
  selectedBackground: "#F2F7FD",
  selectedBorder: "#A9C4E4",
  selectedControl: "#2B598C",
  detailBranchMarginLeft: "26px",
  reportBranchMarginLeft: "22px",
  branchPaddingLeft: "16px"
};

export const getSurveyQuestionChrome = (hasConditionals, isNested = false) => {
  if (hasConditionals && isNested) {
    return {
      backgroundColor: SURVEY_QUESTION_CHROME.conditionalChildBackground,
      borderColor: SURVEY_QUESTION_CHROME.conditionalChildBorder
    };
  }

  if (hasConditionals) {
    return {
      backgroundColor: SURVEY_QUESTION_CHROME.conditionalRootBackground,
      borderColor: SURVEY_QUESTION_CHROME.conditionalRootBorder
    };
  }

  return {
    backgroundColor: SURVEY_QUESTION_CHROME.plainBackground,
    borderColor: SURVEY_QUESTION_CHROME.plainBorder
  };
};

export const NESTED_HIGHLIGHT_COLORS = {
  border: SURVEY_QUESTION_CHROME.conditionalRootBorder,
  headerBackground: SURVEY_QUESTION_CHROME.conditionalRootBackground,
  questionText: SURVEY_QUESTION_CHROME.titleColor
};

export const NESTED_HIGHLIGHT_STYLES = {
  cardSxOverride: {
    border: `1px solid ${SURVEY_QUESTION_CHROME.conditionalChildBorder}`
  },
  headerSxOverride: {
    backgroundColor: SURVEY_QUESTION_CHROME.conditionalChildBackground
  }
};

/* =========================
   ChoiceOptionsEditor
========================= */

export const CHOICE_OPTION_EDITOR_DEFAULTS = {
  type: SURVEY_TYPES.singleChoice,
  multipleChoiceType: SURVEY_TYPES.multipleChoice,
  options: [],
  rowSx: {},
  inputSx: {},
  addActionSx: {}
};

export const CHOICE_OPTION_EDITOR_TEXTS = {
  addAction: "Agregar opción",
  optionPlaceholder: "Opción",
  requiredOption: "La opción es obligatoria"
};

export const CHOICE_OPTION_EDITOR_STYLES = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 1.5
  },
  optionWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: 0.5
  },
  optionRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    border: "1px solid",
    borderRadius: "8px",
    padding: "10px 14px",
    backgroundColor: "#FFFFFF",
    gap: 1.5
  },
  optionContent: {
    display: "flex",
    alignItems: "center",
    gap: 1.25,
    flex: 1,
    minWidth: 0
  },
  actionsContainer: {
    display: "flex",
    alignItems: "center",
    gap: 1
  },
  defaultBorderColor: "#D9D9D9",
  errorBorderColor: "#D32F2F"
};

export const CHOICE_OPTION_CONTROL_SX = {
  p: 0,
  mr: 0.5,
  color: "rgba(0,0,0,0.26)",
  pointerEvents: "none",
  "& .MuiSvgIcon-root": {
    fontSize: 18
  }
};

export const CHOICE_OPTION_INPUT_SX = {
  flex: 1,
  "& .MuiInputBase-input": {
    fontSize: 15,
    color: "#2F2F2F",
    fontWeight: 400
  },
  "& .MuiInputBase-input::placeholder": {
    color: "#9CA3AF",
    opacity: 1
  }
};

export const CHOICE_OPTION_DELETE_BUTTON_SX = {
  p: 0,
  "&:hover": {
    backgroundColor: "transparent"
  }
};

export const CHOICE_OPTION_ERROR_TEXT_SX = {
  fontSize: 12,
  color: "#D32F2F",
  ml: 5
};

export const CHOICE_OPTION_ADD_ACTION_SX = {
  display: "inline-flex",
  alignItems: "center",
  gap: 1,
  color: SURVEY_QUESTION_CHROME.addOption,
  cursor: "pointer",
  fontWeight: 500,
  fontSize: 16,
  width: "fit-content"
};

/* =========================
   BaseQuestionCard
========================= */

export const BASE_QUESTION_CARD_DEFAULTS = {
  answerFieldProps: {},
  extraContent: null,
  canCollapse: true,
  showFooter: false,
  footerContent: null,
  menuItems: null,
  headerSxOverride: null,
  extraHeaderContent: null,
  chipSxOverride: null,
  cardSxOverride: null,
  questionTextSxOverride: null,
  questionLabel: null,
  isNested: false,
  parentOptionLabel: "",
  parentOptionLabelColor: SURVEY_QUESTION_CHROME.noteText,
  showRequiredImagePreview: true
};

export const BASE_QUESTION_CARD_MENU_LABELS = {
  duplicate: "Duplicar",
  delete: "Eliminar"
};

export const BASE_QUESTION_CARD_TEXTS = {
  questionPrefix: "Pregunta",
  titlePlaceholder: "Escriba el título de su pregunta",
  descriptionPlaceholder: "Descripción opcional",
  requiredTitle: "El título es obligatorio",
  requiredImageFooter: "Esta pregunta requerirá al menos 1 imagen",
  parentOptionPrefix: 'Si eligen: "',
  quoteSuffix: '"',
  ellipsis: "..."
};

export const BASE_QUESTION_CARD_STYLES = {
  headerBase: {
    display: "flex",
    alignItems: "center",
    minWidth: 0
  },
  headerDefaultGap: 1,
  headerNestedGap: 0.5,
  headerNestedPx: "8px",
  headerNestedPy: "6px",

  dragHandleNestedMr: 0.25,
  dragIconNestedFontSize: 18,

  nestedQuestionTextFontSize: { xs: 12, sm: 14 },

  nestedChipMaxWidth: 110,
  defaultChipMaxWidth: { xs: 110, sm: "unset" },
  nestedChipLabelPx: 1,
  nestedChipLabelFontSize: 12,

  parentOptionNestedMl: 0.5,
  parentOptionDefaultMl: 1,
  parentOptionNestedFontSize: 11,
  parentOptionDefaultFontSize: 12,
  parentOptionNestedMaxWidth: 200,
  parentOptionDefaultMaxWidth: 180,
  parentOptionPreviewLength: 5,
  parentOptionEllipsisThreshold: 3,

  extraHeaderContent: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    minWidth: 0,
    overflow: "hidden"
  },

  flexGrowSpacer: {
    flexGrow: 1,
    minWidth: 0
  },

  actionsContainer: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0
  },
  actionsDefaultGap: 0.5,
  actionsNestedGap: 0,

  iconButtonNestedPadding: 0.5,
  actionIconNestedFontSize: 20
};

/* =========================
   SingleChoiceQuestionCard
========================= */

export const SINGLE_CHOICE_CARD_DEFAULTS = {
  initialLevel: 1,
  firstChildIndex: 1
};

export const SINGLE_CHOICE_CARD_MENU_LABELS = {
  duplicate: "Duplicar",
  addConditional: "Agregar condicional",
  removeConditional: "Quitar condicional",
  delete: "Eliminar"
};

export const SINGLE_CHOICE_CARD_TEXTS = {
  hasConditionalsChip: "Tiene condicionales",
  removeConditionalConfirmation:
    "¿Quitar condicional?\n\nEsta acción eliminará todas las preguntas dependientes asociadas.",
  deleteOptionConfirmation:
    "¿Está seguro de borrar esta opción?\n\nAl confirmar esta acción, se borrarán las preguntas condicionales a esta opción.",
  deleteQuestionConfirmation:
    "¿Está seguro de borrar esta pregunta?\n\nAl confirmar esta acción, se borrarán las preguntas condicionales a esta pregunta.",
  replaceConditionalConfirmation:
    "¿Reemplazar por otro tipo de pregunta?\n\nEsta acción eliminará todas las preguntas dependientes asociadas al reemplazar la pregunta Condicional."
};

export const SINGLE_CHOICE_CARD_STYLES = {
  defaultParentOptionTextColor: SURVEY_QUESTION_CHROME.noteText,
  highlightParentOptionTextColor: "#EA580C",

  highlightCardSx: {
    border: `1px solid ${SURVEY_QUESTION_CHROME.conditionalRootBorder}`
  },
  highlightHeaderSx: {
    backgroundColor: SURVEY_QUESTION_CHROME.conditionalRootBackground
  },
  highlightQuestionTextSx: {
    color: SURVEY_QUESTION_CHROME.titleColor,
    fontWeight: SURVEY_QUESTION_CHROME.titleFontWeight
  },

  childQuestionsChipSx: {
    backgroundColor: SURVEY_QUESTION_CHROME.chipBackground,
    color: SURVEY_QUESTION_CHROME.chipText
  },

  conditionalChipBackgroundColor: "#FF893D",
  conditionalChipTextColor: "#FFFFFF",
  conditionalChipFontWeight: 600,
  conditionalChipNestedMl: 0.5,
  conditionalChipDefaultMl: 1,
  conditionalChipNestedFontSize: 11,
  conditionalChipDefaultFontSize: 12,
  conditionalChipNestedMaxWidth: 200,
  conditionalChipDefaultMaxWidth: "unset",
  conditionalChipNestedLabelPx: 1
};

/* =========================
   Survey report (answered survey, read-only)
========================= */

export const SURVEY_REPORT_TEXTS = {
  answerLabel: "Respuesta:",
  emptyAnswer: "Sin respuesta",
  parentOptionPrefix: 'Eligió: "'
};

export const SURVEY_REPORT_STYLES = {
  selectedOptionBackgroundColor: SURVEY_QUESTION_CHROME.selectedBackground,
  selectedOptionBorderColor: SURVEY_QUESTION_CHROME.selectedBorder,
  selectedOptionControlColor: SURVEY_QUESTION_CHROME.selectedControl,
  selectedOptionTextColor: SURVEY_QUESTION_CHROME.fieldText,
  nestedHeaderBackgroundColor: SURVEY_QUESTION_CHROME.conditionalChildBackground,
  nestedQuestionTitleColor: SURVEY_QUESTION_CHROME.titleColor,
  questionTitleFontWeight: SURVEY_QUESTION_CHROME.titleFontWeight,
  questionTitleFontSize: 14,
  questionTitleLineHeight: 1.45,
  questionTitleColor: SURVEY_QUESTION_CHROME.titleColor
};

/* =========================
   MultipleChoiceQuestion
========================= */

export const MULTIPLE_CHOICE_QUESTION_DEFAULTS = {
  initialOptionsCount: 2
};

/* =========================
   SingleChoiceOptionsSection
========================= */

export const SINGLE_CHOICE_OPTIONS_SECTION_DEFAULTS = {
  childLevel: 2,
  arrowIconSize: 30,
  conditionalSelectorMinWidth: 124,
  conditionalSelectorHeight: 40
};

export const SINGLE_CHOICE_OPTIONS_SECTION_TEXTS = {
  conditionalSelectorDefaultLabel: NO_CONDITIONAL_LABEL,
  arrowUpIcon: "arrow_drop_up",
  arrowDownIcon: "arrow_drop_down"
};

export const SINGLE_CHOICE_OPTIONS_SECTION_STYLES = {
  childQuestionWrapper: {
    mt: 1.25,
    mb: "12px",
    ml: "18px",
    pl: SURVEY_QUESTION_CHROME.branchPaddingLeft,
    borderLeft: `3px solid ${SURVEY_QUESTION_CHROME.branchBorder}`
  },

  conditionalSelector: {
    minWidth: SINGLE_CHOICE_OPTIONS_SECTION_DEFAULTS.conditionalSelectorMinWidth,
    height: SINGLE_CHOICE_OPTIONS_SECTION_DEFAULTS.conditionalSelectorHeight,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
    px: 1.5,
    border: "1px solid",
    borderRadius: "8px",
    cursor: "pointer",
    userSelect: "none"
  },

  conditionalSelectorActive: {
    borderColor: NESTED_HIGHLIGHT_COLORS.border,
    backgroundColor: "#FFF3E0",
    color: SINGLE_CHOICE_CARD_STYLES.conditionalChipBackgroundColor
  },

  conditionalSelectorInactive: {
    borderColor: "#D0D5DD",
    backgroundColor: "#FFFFFF",
    color: "#5F6368"
  },

  conditionalSelectorText: {
    fontSize: 14,
    fontWeight: 600,
    color: "inherit",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },

  conditionalSelectorIcon: {
    flexShrink: 0
  }
};
